import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { Fieldset } from "primereact/fieldset";
import Swal from "sweetalert2";
import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";
import {
    getAllChoferNames,
    getAllColabNames,
    getContactInformation,
    getDescuentosColaboradores,
    getDescuentosHerramientas,
    getDescuentosOperadores,
    getGrupos,
    getUnidades,
    insertDescuento,
    sendWhatsapp,
    updateDescuentoColaborador,
    updateDescuentoOperador,
    notifyNuevoDescuento
} from "./integracion";
import {SelectButton} from "primereact/selectbutton";
import {InputIcon} from "primereact/inputicon";
import {IconField} from "primereact/iconfield";

// ==================== CONSTANTES ====================
const MODO = {
    COLABORADORES: "COLABORADORES",
    OPERADORES: "OPERADORES"
};

const ESTATUS_OPTIONS = [
    { label: "POR CAPTURAR", value: 1, color: "#616161" },
    { label: "EN PROCESO", value: 2, color: "#ed6c02" },
    { label: "CONCLUIDO", value: 3, color: "#2e7d32" }
];

const DESCUENTO_PORCENTAJE_OPTIONS = [
    { label: "40%", value: 40 },
    { label: "50%", value: 50 },
    { label: "75%", value: 75 },
    { label: "100%", value: 100 }
];

const MODO_OPTIONS = [
    { label: 'Colaboradores', value: MODO.COLABORADORES },
    { label: 'Operadores', value: MODO.OPERADORES }
];

const INITIAL_FORM_STATE = {
    FECHA_FORMAT: new Date(),
    NOMBRE_USUARIO: "",
    idEntidad: null,
    MONTO: null,
    idGrupo: null,
    NO_DESCUENTOS: null,
    MONTO_DESCUENTO: null,
    motivo: "",
    ID_UNIDAD: null,
    periodoInicio: "",
    ESTATUS: 1,
    ID_REEMBOLSO: null,
    DESCUENTO_HERRAMIENTA: null,
    DESCUENTO_PORCENTAJE: null
};

// ==================== UTILIDADES ====================
const toIsoUtcStartOfDay = (input) => {
    if (!input) return null;

    if (input instanceof Date && !isNaN(input)) {
        const d = new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate(), 0, 0, 0, 0));
        return d.toISOString();
    }

    if (typeof input === 'string') {
        const s = input.trim();

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
            const [dd, mm, yyyy] = s.split('/').map(Number);
            const d = new Date(Date.UTC(yyyy, mm - 1, dd, 0, 0, 0, 0));
            return isNaN(d) ? null : d.toISOString();
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            const [yyyy, mm, dd] = s.split('-').map(Number);
            const d = new Date(Date.UTC(yyyy, mm - 1, dd, 0, 0, 0, 0));
            return isNaN(d) ? null : d.toISOString();
        }

        if (!isNaN(new Date(s))) {
            const d = new Date(s);
            const utc = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0, 0));
            return utc.toISOString();
        }
    }

    return null;
};

export const normalizeToDate = (sOrDate) => {
    if (!sOrDate) return null;
    if (sOrDate instanceof Date) return sOrDate;

    if (typeof sOrDate === 'string') {
        if (sOrDate.includes('/')) {
            const [dd, mm, yyyy] = sOrDate.split('/').map(Number);
            return new Date(yyyy, mm - 1, dd);
        }
        if (sOrDate.includes('-')) {
            const [yyyy, mm, dd] = sOrDate.split('-').map(Number);
            return new Date(yyyy, mm - 1, dd);
        }
    }
    return null;
};

const formatCurrency = (n) =>
    typeof n === "number"
        ? n.toLocaleString("es-MX", { style: "currency", currency: "MXN" })
        : "";

const parseRowDate = (row) => {
    const v = row?.FECHA_FORMAT;
    if (!v) return null;
    if (v instanceof Date) return isNaN(v) ? null : v;

    if (typeof v === "string") {
        const m1 = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (m1) return new Date(Number(m1[3]), Number(m1[2]) - 1, Number(m1[1]));
        const d = new Date(v);
        return isNaN(d) ? null : d;
    }
    return null;
};

const getRowStatusVal = (row) => {
    if (row.ESTATUS != null) return Number(row.ESTATUS);
    const nombre = (row.NOMBRE_ESTATUS || "").toUpperCase();
    return nombre === "POR CAPTURAR" ? 1 : nombre === "EN PROCESO" ? 2 : nombre === "CONCLUIDO" ? 3 : null;
};

// ==================== COMPONENTE PRINCIPAL ====================
const Descuentos = () => {
    // Estados
    const [modo, setModo] = useState(MODO.COLABORADORES);
    const [dataColaboradores, setDataColaboradores] = useState([]);
    const [dataOperadores, setDataOperadores] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [units, setUnits] = useState([]);
    const [colabList, setColabList] = useState([]);
    const [choferNames, setChoferNames] = useState([]);
    const [herramientasOptions, setHerramientasOptions] = useState([]);

    const [first, setFirst] = useState(0);
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [form, setForm] = useState(INITIAL_FORM_STATE);
    const [errors, setErrors] = useState({});

    const dataUser = useGetDataUser();
    const discTable = useRef(null);

    // ==================== EFECTOS ====================
    useEffect(() => {
        const today = new Date();
        const from = new Date();
        from.setDate(today.getDate() - 30);
        setDateFrom(from);
        setDateTo(today);
    }, []);

    useEffect(() => {
        if (form.DESCUENTO_PORCENTAJE != null && form.MONTO != null) {
            const pct = Number(form.DESCUENTO_PORCENTAJE) / 100;
            const descuento = Math.round((form.MONTO * pct + Number.EPSILON) * 100) / 100;
            setForm(f => ({ ...f, MONTO_DESCUENTO: descuento }));
        }
    }, [form.MONTO, form.DESCUENTO_PORCENTAJE]);

    useEffect(() => {
        loadUsers();
        loadDataColaboradores();
        loadDataOperadores();
        loadUnits();
    }, []);

    useEffect(() => {
        loadHerramientas();
    }, [modo]);

    // ==================== CARGA DE DATOS ====================
    const loadDataColaboradores = async () => {
        try {
            const [descColab, grupos] = await Promise.all([
                getDescuentosColaboradores(),
                getGrupos()
            ]);
            setDataColaboradores(descColab || []);
            setGrupos(grupos || []);
        } catch (error) {
            console.error("Error fetching colaboradores data:", error);
            Swal.fire({ icon: "error", title: "Error", text: "Error al cargar datos de colaboradores" });
        }
    };

    const loadDataOperadores = async () => {
        try {
            const descOperadores = await getDescuentosOperadores();
            setDataOperadores(descOperadores || []);
        } catch (error) {
            console.error("Error fetching operadores data:", error);
            Swal.fire({ icon: "error", title: "Error", text: "Error al cargar datos de operadores" });
        }
    };

    const loadUsers = async () => {
        try {
            const [colabList, choferList] = await Promise.all([
                getAllColabNames(),
                getAllChoferNames()
            ]);
            setColabList(colabList || []);
            setChoferNames(choferList || []);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const loadUnits = async () => {
        try {
            const unitResponse = await getUnidades();
            setUnits(unitResponse || []);
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const loadHerramientas = async () => {
        try {
            const herramientas = await getDescuentosHerramientas(modo === MODO.COLABORADORES);
            setHerramientasOptions(herramientas || []);
        } catch (error) {
            console.error("Error fetching herramientas:", error);
        }
    };

    // ==================== HELPERS ====================
    const getNombreUnidad = (id) => units.find(u => u.value === id)?.label ?? null;
    const getNombreGrupo = (id) => grupos.find(g => g.value === id)?.label ?? null;
    const getNombreHerramienta = (id) => herramientasOptions.find(h => h.value === id)?.label ?? null;
    const getNombreColaborador = (id) => colabList.find(c => c.value === id)?.label ?? null;
    const getNombreOperador = (id) => choferNames.find(o => o.value === id)?.label ?? null;
    const getNombreEstatus = (val) => ({ 1: 'POR CAPTURAR', 2: 'EN PROCESO', 3: 'CONCLUIDO' }[Number(val)] ?? val);

    // ==================== FILTRADO ====================
    const applyFilters = (list) => {
        if (!Array.isArray(list)) return [];

        return list.filter((row) => {
            if (statusFilter != null) {
                const estatusVal = getRowStatusVal(row);
                if (estatusVal !== statusFilter) return false;
            }

            const d = parseRowDate(row);
            if (!d) return false;

            if (dateFrom && d < new Date(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate(), 0, 0, 0, 0)) {
                return false;
            }

            if (dateTo && d > new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate(), 23, 59, 59, 999)) {
                return false;
            }

            return true;
        });
    };

    const rowsRaw = modo === MODO.COLABORADORES ? dataColaboradores : dataOperadores;
    const rows = applyFilters(rowsRaw);

    // ==================== VALIDACIÓN ====================
    const validate = () => {
        const e = {};
        if (!form.idEntidad) e.idEntidad = "Requerido";
        if (!form.idGrupo) e.idGrupo = "Requerido";
        if (!form.DESCUENTO_HERRAMIENTA) e.DESCUENTO_HERRAMIENTA = "Requerido";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    // ==================== OPERACIONES CRUD ====================
    const handleNuevoDescuento = () => {
        setEditingRow(null);
        setErrors({});
        setForm({ ...INITIAL_FORM_STATE });
        setDialogOpen(true);
    };

    const handleEditarDescuento = (row) => {
        setForm({
            FECHA_FORMAT: normalizeToDate(row.FECHA_FORMAT),
            NOMBRE_USUARIO: row.NOMBRE_USUARIO ?? "",
            idEntidad: row.ID_COLABORADOR ?? row.ID_CHOFER,
            MONTO: row.MONTO ?? null,
            idGrupo: row.ID_GRUPO_SOLICITA,
            NO_DESCUENTOS: row.NO_DESCUENTOS ?? null,
            MONTO_DESCUENTO: row.MONTO_DESCUENTO ?? null,
            motivo: row.MOTIVO ?? "",
            periodoInicio: row.PERIODO_INICIO ?? null,
            ESTATUS: row.ESTATUS,
            ID_UNIDAD: row.ID_UNIDAD ?? null,
            ID_REEMBOLSO: row.ID_REEMBOLSO ?? null,
            DESCUENTO_HERRAMIENTA: row.ID_DESCUENTO_HERRAM,
            DESCUENTO_PORCENTAJE: null
        });
        setEditingRow(row);
        setErrors({});
        setDialogOpen(true);
    };

    const buildPayload = () => {
        const basePayload = {
            ...(editingRow?.ID ? { ID: editingRow.ID } : {}),
            FECHA: toIsoUtcStartOfDay(form.FECHA_FORMAT) ?? "1970-01-01T00:00:00.000Z",
            ID_GRUPO_SOLICITA: form.idGrupo,
            MONTO: form.MONTO,
            NO_DESCUENTOS: form.NO_DESCUENTOS ? String(form.NO_DESCUENTOS) : null,
            MONTO_DESCUENTO: form.MONTO_DESCUENTO,
            MOTIVO: form.motivo,
            PERIODO_INICIO: form.periodoInicio ? String(form.periodoInicio) : null,
            ESTATUS: form.ESTATUS,
            ID_DESCUENTO_HERRAM: form.DESCUENTO_HERRAMIENTA
        };

        if (modo === MODO.COLABORADORES) {
            return { ...basePayload, ID_COLABORADOR: form.idEntidad };
        } else {
            return {
                ...basePayload,
                ID_CHOFER: form.idEntidad,
                ID_UNIDAD: form.ID_UNIDAD,
                ID_REEMBOLSO: form.ID_REEMBOLSO
            };
        }
    };

    const showLoading = () => {
        Swal.fire({
            icon: "info",
            title: "Cargando...",
            text: "Espere por favor...",
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => Swal.showLoading()
        });
    };

    const sendNotifications = async (payload, responseId) => {
        try {
            const paramsNuevo = {
                ID: responseId,
                FECHA: payload.FECHA,
                USUARIO: dataUser?.user?.NOMBRE || "",
                DEPARTAMENTO: getNombreGrupo(payload.ID_GRUPO_SOLICITA) ?? null,
                HERRAMIENTA: getNombreHerramienta(payload.ID_DESCUENTO_HERRAM) ?? null,
                UNIDAD: getNombreUnidad(payload.ID_UNIDAD) ?? null,
                OPERADOR: getNombreOperador(payload.ID_CHOFER) ?? null,
                COLABORADOR: getNombreColaborador(payload.ID_COLABORADOR) ?? null,
                MONTO: payload.MONTO,
                NO_DESCUENTOS: payload.NO_DESCUENTOS,
                MONTO_DESCUENTO: payload.MONTO_DESCUENTO,
                PERIODO_INICIO: payload.PERIODO_INICIO,
                ESTATUS: getNombreEstatus(payload.ESTATUS) ?? null,
                MOTIVO: payload.MOTIVO
            };

            const params = {
                type: payload.ID_COLABORADOR ? "COLABORADOR" : "OPERADOR",
                id_affected: payload.ID_COLABORADOR ? payload.ID_COLABORADOR : payload.ID_CHOFER,
                id: dataUser?.user?.ID
            };

            const contactInfo = await getContactInformation(params);

            try {
                const emails = [contactInfo.email_user, contactInfo.email_afectado];
                await notifyNuevoDescuento(paramsNuevo, emails);
            } catch (e) {
                console.warn('No se pudo enviar la notificación de nuevo descuento (email)', e);
            }

            try {
                const telefonoDestino = contactInfo.phone_afectado;
                if (telefonoDestino) {
                    await sendWhatsapp({
                        phones: [telefonoDestino],
                        details: paramsNuevo
                    });
                }
            } catch (e) {
                console.warn('No se pudo enviar la notificación por WhatsApp', e);
            }
        } catch (e) {
            console.error('Error: No se pudo obtener la info de contacto. No se envió ninguna notificación.', e);
        }
    };

    const saveOrUpdateDescuento = async (payload) => {
        showLoading();

        try {
            if (payload.ID) {
                const updateFn = payload.ID_COLABORADOR ? updateDescuentoColaborador : updateDescuentoOperador;
                const response = await updateFn(payload);

                if (response?.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Descuento actualizado",
                        text: "El descuento ha sido actualizado correctamente"
                    });
                } else {
                    throw new Error("Error al actualizar el descuento");
                }

                if (modo === MODO.COLABORADORES) {
                    await loadDataColaboradores();
                } else {
                    await loadDataOperadores();
                }
            } else {
                payload.USUARIO = dataUser?.user?.ID;
                const resp = await insertDescuento(payload);

                if (resp?.success) {
                    Swal.fire({ icon: "success", title: "Descuento creado" });

                    const responseId = resp?.id ?? resp?.data?.id ?? null;
                    await sendNotifications(payload, responseId);

                    if (modo === MODO.COLABORADORES) {
                        await loadDataColaboradores();
                    } else {
                        await loadDataOperadores();
                    }
                } else {
                    throw new Error(resp?.message || "No se pudo crear el descuento");
                }
            }

            setDialogOpen(false);
            setEditingRow(null);
        } catch (error) {
            console.error("Error guardando descuento:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Error al guardar el descuento"
            });
        }
    };

    const onSave = async () => {
        if (!validate()) return;
        const payload = buildPayload();
        await saveOrUpdateDescuento(payload);
    };

    // ==================== HANDLERS ====================
    const handleClearFilters = () => {
        setDateFrom(null);
        setDateTo(null);
        setStatusFilter(null);
    };

    const exportCSV = () => {
        discTable.current?.exportCSV();
    };

    // ==================== TEMPLATES ====================
    const renderStatusOption = (option) => {
        if (!option || option.value === null) return <span>Todos</span>;
        return (
            <div className="flex align-items-center gap-2">
                <span className="border-circle" style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: option.color
                }} />
                <span>{option.label}</span>
            </div>
        );
    };

    const EditarTemplate = (row) => (
        <Button
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            onClick={() => handleEditarDescuento(row)}
            aria-label="Editar"
        />
    );

    const MotivosTemplate = (row) => {
        const iconRef = useRef(null);
        return (
            <>
                <i
                    ref={iconRef}
                    className="pi pi-comments cursor-pointer"
                    aria-label="Motivo"
                />
                <Tooltip target={iconRef} content={row.MOTIVO || "Sin motivo"} position="top" />
            </>
        );
    };

    const estatusTemplate = (row) => {
        const statusOption = ESTATUS_OPTIONS.find(opt => opt.label === row.NOMBRE_ESTATUS);
        const color = statusOption?.color || "#616161";

        return (
            <span className="font-semibold" style={{ color }}>
                {row.NOMBRE_ESTATUS}
            </span>
        );
    };

    // ==================== HEADER ====================
    const header = (
        <div className="flex flex-column gap-3 p-3">
            {/* Fila 1: Acciones principales */}
            <div className="grid align-items-center w-full">

                {/* Tabs / SelectButton */}
                <div className="col-12 md:col-3 lg:col-3">
                    <SelectButton
                        value={modo}
                        onChange={(e) => setModo(e.value)}
                        options={MODO_OPTIONS}
                        className="w-full"
                    />
                </div>

                {/* Buscador (flex-grow real) */}
                <div className="col-12 md:col-9 lg:col-6">
                    <IconField iconPosition="left" className="w-full">
                        <InputIcon className="pi pi-search" />
                        <InputText
                            onInput={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Buscar por ID, Usuario o Nombre..."
                            className="w-full"
                        />
                    </IconField>
                </div>

                {/* Acciones (alineadas a la derecha) */}
                <div className="col-12 lg:col-3">
                    <div className="flex gap-2 justify-content-start lg:justify-content-end">
                        <Button
                            label="Nuevo"
                            icon="pi pi-plus"
                            className="w-full sm:w-auto"
                            onClick={handleNuevoDescuento}
                        />
                        <Button
                            label="Exportar"
                            icon="pi pi-file-excel"
                            className="p-button-success w-full sm:w-auto"
                            onClick={exportCSV}
                        />
                    </div>
                </div>

            </div>

            {/* Fila 2: Filtros */}
            <div className="flex gap-3 align-items-center p-2 bg-gray-100 border-round flex-wrap">
                <div className="flex align-items-center gap-2">
                    <span className="text-xs font-bold">Rango:</span>
                    <Calendar
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.value)}
                        placeholder="Desde"
                        dateFormat="dd/mm/yy"
                        showIcon
                        style={{ width: '170px' }}
                    />
                    <Calendar
                        value={dateTo}
                        onChange={(e) => setDateTo(e.value)}
                        placeholder="Hasta"
                        dateFormat="dd/mm/yy"
                        showIcon
                        style={{ width: '170px' }}
                    />
                </div>

                <div className="flex align-items-center gap-2">
                    <span className="text-xs font-bold">Estatus:</span>
                    <Dropdown
                        value={statusFilter}
                        options={ESTATUS_OPTIONS}
                        onChange={(e) => setStatusFilter(e.value)}
                        placeholder="Todos"
                        style={{ width: "180px" }}
                        itemTemplate={renderStatusOption}
                        valueTemplate={renderStatusOption}
                        showClear
                    />
                </div>

                <Button
                    icon="pi pi-filter-slash"
                    className="p-button-text p-button-secondary"
                    onClick={handleClearFilters}
                    tooltip="Limpiar Filtros"
                />
            </div>
        </div>
    );

    // ==================== DIALOG FOOTER ====================
    const dialogFooter = (
        <div className="flex justify-content-end gap-2">
            <Button
                label="Cancelar"
                className="p-button-text"
                onClick={() => {
                    setDialogOpen(false);
                    setEditingRow(null);
                }}
            />
            <Button label="Guardar" icon="pi pi-save" onClick={onSave} />
        </div>
    );

    // ==================== COLUMNAS ====================
    const idEntidadField = modo === MODO.COLABORADORES ? "NOMBRE_COLABORADOR" : "NOMBRE_OPERADOR";
    const idEntidadHeader = modo === MODO.COLABORADORES ? "COLABORADOR" : "OPERADOR";

    // ==================== RENDER ====================
    return (
        <div className="parent-flex-container-discount">
            <div className="datatable-wrapper-discount">
                <DataTable
                    value={rows}
                    ref={discTable}
                    header={header}
                    className="custom-table-th discount-table--compact"
                    emptyMessage="No hay descuentos disponibles."
                    paginator
                    exportFilename="descuentos"
                    scrollable
                    scrollHeight="calc(100vh - 300px)"
                    rows={50}
                    rowsPerPageOptions={[50, 100, 200]}
                    first={first}
                    globalFilter={globalFilter}
                    globalFilterFields={['ID', 'NOMBRE_USUARIO', idEntidadField]}
                    onPage={(e) => setFirst(e.first)}
                >
                    <Column header="Editar" body={EditarTemplate} style={{ width: "80px" }} />
                    <Column field="ID" header="ID" style={{ width: "100px" }} />
                    <Column field="FECHA_FORMAT" header="Fecha" style={{ width: "140px" }} />
                    <Column field="NOMBRE_USUARIO" header="Usuario" style={{ width: "160px" }} />
                    <Column field={idEntidadField} header={idEntidadHeader} style={{ width: "160px" }} />
                    <Column
                        field="MONTO"
                        header="MONTO"
                        sortable
                        body={(r) => formatCurrency(r.MONTO)}
                        style={{ width: "140px" }}
                    />
                    <Column field="NO_DESCUENTOS" header="NO DESCUENTO" style={{ width: "160px" }} />
                    <Column
                        field="MONTO_DESCUENTO"
                        header="MONTO DESCUENTO"
                        sortable
                        body={(r) => formatCurrency(r.MONTO_DESCUENTO)}
                        style={{ width: "190px" }}
                    />
                    {modo === MODO.OPERADORES && (
                        <Column field="ID_UNIDAD" header="ID Unidad" style={{ width: "80px" }} />
                    )}
                    <Column header="MOTIVOS" field="MOTIVO" body={MotivosTemplate} style={{ width: "120px" }} />
                    <Column field="PERIODO_INICIO" header="PERIODO INICIO" style={{ width: "160px" }} />
                    <Column field="NOMBRE_ESTATUS" header="ESTATUS" body={estatusTemplate} style={{ width: "140px" }} />
                </DataTable>
            </div>

            {/* Dialog */}
            <Dialog
                header={editingRow ? "Editar descuento" : "Nuevo descuento"}
                visible={dialogOpen}
                modal
                style={{ width: '800px', maxWidth: '95vw' }}
                onHide={() => {
                    setDialogOpen(false);
                    setEditingRow(null);
                }}
                footer={dialogFooter}
            >
                <div className="formgrid grid">
                    {/* Fila 1 */}
                    <div className="field col-12 md:col-6">
                        <label className="block mb-2">{modo === MODO.COLABORADORES ? "Colaborador" : "Operador"}</label>
                        <Dropdown
                            value={form.idEntidad}
                            filter
                            options={modo === MODO.COLABORADORES ? colabList : choferNames}
                            onChange={(e) => setForm((f) => ({ ...f, idEntidad: e.value }))}
                            placeholder="Selecciona usuario"
                            className={`w-full ${errors.idEntidad ? "p-invalid" : ""}`}
                            showClear
                            disabled={!colabList?.length && !choferNames?.length}
                        />
                        {errors.idEntidad && <small className="p-error block mt-1">{errors.idEntidad}</small>}
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="block mb-2">Grupo Solicita</label>
                        <Dropdown
                            value={form.idGrupo}
                            filter
                            options={grupos}
                            onChange={(e) => setForm((f) => ({ ...f, idGrupo: e.value }))}
                            placeholder="Selecciona grupo"
                            className={`w-full ${errors.idGrupo ? "p-invalid" : ""}`}
                            showClear
                            disabled={!grupos?.length}
                        />
                        {errors.idGrupo && <small className="p-error block mt-1">{errors.idGrupo}</small>}
                    </div>

                    {/* Fila 2 */}
                    <div className="field col-12 md:col-6">
                        <label className="block mb-2">Descuento Herramienta</label>
                        <Dropdown
                            value={form.DESCUENTO_HERRAMIENTA}
                            options={herramientasOptions}
                            onChange={(e) => setForm((f) => ({ ...f, DESCUENTO_HERRAMIENTA: e.value }))}
                            placeholder="Selecciona descuento"
                            className={`w-full ${errors.DESCUENTO_HERRAMIENTA ? "p-invalid" : ""}`}
                            showClear
                            disabled={!herramientasOptions?.length}
                        />
                        {errors.DESCUENTO_HERRAMIENTA && (
                            <small className="p-error block mt-1">{errors.DESCUENTO_HERRAMIENTA}</small>
                        )}
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="block mb-2">Fecha</label>
                        <Calendar
                            value={form.FECHA_FORMAT || null}
                            onChange={(e) => setForm(f => ({ ...f, FECHA_FORMAT: e.value || null }))}
                            dateFormat="dd/mm/yy"
                            showIcon
                            className="w-full"
                        />
                    </div>

                    {/* Usuario que registró (solo en edición) */}
                    {editingRow && (
                        <div className="field col-12 md:col-6">
                            <label className="block mb-2">Usuario que registró</label>
                            <InputText value={form.NOMBRE_USUARIO} readOnly className="w-full" />
                        </div>
                    )}

                    {/* Fieldset para información de TH */}
                    <div className="col-12">
                        <Fieldset legend="Información exclusiva de TH">
                            <div className="formgrid grid">
                                <div className="field col">
                                    <label className="block mb-2">No. Descuentos</label>
                                    <InputNumber
                                        value={form.NO_DESCUENTOS}
                                        onValueChange={(e) => setForm((f) => ({ ...f, NO_DESCUENTOS: e.value }))}
                                        useGrouping={false}
                                        className="w-full"
                                    />
                                </div>

                                <div className="field col">
                                    <label className="block mb-2">Monto</label>
                                    <InputNumber
                                        value={form.MONTO}
                                        onValueChange={(e) => setForm((f) => ({ ...f, MONTO: e.value }))}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                        className="w-full"
                                    />
                                </div>

                                <div className="field col">
                                    <label className="block mb-2">Descuento (%)</label>
                                    <Dropdown
                                        value={form.DESCUENTO_PORCENTAJE}
                                        options={DESCUENTO_PORCENTAJE_OPTIONS}
                                        onChange={(e) => setForm(f => ({ ...f, DESCUENTO_PORCENTAJE: e.value }))}
                                        placeholder="Selecciona %"
                                        showClear
                                        className="w-full"
                                    />
                                </div>

                                <div className="field col">
                                    <label className="block mb-2">Monto Descuento</label>
                                    <InputNumber
                                        value={form.MONTO_DESCUENTO}
                                        onValueChange={(e) => setForm((f) => ({ ...f, MONTO_DESCUENTO: e.value }))}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </Fieldset>
                    </div>

                    {/* Fila 3 */}
                    <div className="field col-12 md:col-6">
                        <label className="block mb-2">Periodo Inicio</label>
                        <InputText
                            value={form.periodoInicio || ""}
                            onChange={(e) => setForm((f) => ({ ...f, periodoInicio: e.target.value }))}
                            placeholder="Periodo de inicio"
                            className="w-full"
                        />
                    </div>

                    {modo === MODO.OPERADORES && (
                        <div className="field col-12 md:col-6">
                            <label className="block mb-2">ID Reembolso</label>
                            <InputNumber
                                value={form.ID_REEMBOLSO}
                                useGrouping={false}
                                onValueChange={(e) => setForm((f) => ({ ...f, ID_REEMBOLSO: e.value }))}
                                className="w-full"
                            />
                        </div>
                    )}

                    {form.DESCUENTO_HERRAMIENTA === 1 && modo === MODO.OPERADORES && (
                        <div className="field col-12 md:col-6">
                            <label className="block mb-2">ID Unidad</label>
                            <Dropdown
                                value={form.ID_UNIDAD}
                                filter
                                options={units}
                                onChange={(e) => setForm((f) => ({ ...f, ID_UNIDAD: e.value }))}
                                placeholder="Selecciona una unidad"
                                showClear
                                disabled={!units?.length}
                                className="w-full"
                            />
                        </div>
                    )}

                    {/* Fila 4 */}
                    <div className="field col-12">
                        <label className="block mb-2">Motivo</label>
                        <InputText
                            value={form.motivo}
                            onChange={(e) => setForm((f) => ({ ...f, motivo: e.target.value }))}
                            placeholder="Describe el motivo"
                            className="w-full"
                        />
                    </div>

                    {/* Fila 5 */}
                    <div className="field col-12">
                        <label className="block mb-2">Estatus</label>
                        <Dropdown
                            value={form.ESTATUS}
                            options={ESTATUS_OPTIONS}
                            onChange={(e) => setForm((f) => ({ ...f, ESTATUS: e.value }))}
                            className="w-full"
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default Descuentos;
